var map = {
	"./all-you-can-eat-ordering-system/content.de": [
		3760,
		3760
	],
	"./all-you-can-eat-ordering-system/content.de.ts": [
		3760,
		3760
	],
	"./all-you-can-eat-ordering-system/content.en": [
		22,
		7119
	],
	"./all-you-can-eat-ordering-system/content.en.ts": [
		22,
		7119
	],
	"./all-you-can-eat-ordering-system/content.nl": [
		9401,
		9401
	],
	"./all-you-can-eat-ordering-system/content.nl.ts": [
		9401,
		9401
	],
	"./all-you-can-eat-ordering-system/metadata": [
		5025,
		5025
	],
	"./all-you-can-eat-ordering-system/metadata.ts": [
		5025,
		5025
	],
	"./bakery-ordering-software/content.de": [
		2632,
		2632
	],
	"./bakery-ordering-software/content.de.ts": [
		2632,
		2632
	],
	"./bakery-ordering-software/content.en": [
		6174,
		4852
	],
	"./bakery-ordering-software/content.en.ts": [
		6174,
		4852
	],
	"./bakery-ordering-software/content.nl": [
		4843,
		4843
	],
	"./bakery-ordering-software/content.nl.ts": [
		4843,
		4843
	],
	"./bakery-ordering-software/metadata": [
		2768,
		2768
	],
	"./bakery-ordering-software/metadata.ts": [
		2768,
		2768
	],
	"./bowling-alley-digital-ordering/content.de": [
		9991,
		9991
	],
	"./bowling-alley-digital-ordering/content.de.ts": [
		9991,
		9991
	],
	"./bowling-alley-digital-ordering/content.en": [
		8571,
		8571
	],
	"./bowling-alley-digital-ordering/content.en.ts": [
		8571,
		8571
	],
	"./bowling-alley-digital-ordering/content.nl": [
		9554,
		9554
	],
	"./bowling-alley-digital-ordering/content.nl.ts": [
		9554,
		9554
	],
	"./bowling-alley-digital-ordering/metadata": [
		8047,
		8047
	],
	"./bowling-alley-digital-ordering/metadata.ts": [
		8047,
		8047
	],
	"./choosing-ordering-solution/content.de": [
		4001,
		4001
	],
	"./choosing-ordering-solution/content.de.ts": [
		4001,
		4001
	],
	"./choosing-ordering-solution/content.en": [
		9410,
		9410
	],
	"./choosing-ordering-solution/content.en.ts": [
		9410,
		9410
	],
	"./choosing-ordering-solution/content.nl": [
		1870,
		1870
	],
	"./choosing-ordering-solution/content.nl.ts": [
		1870,
		1870
	],
	"./choosing-ordering-solution/metadata": [
		735,
		735
	],
	"./choosing-ordering-solution/metadata.ts": [
		735,
		735
	],
	"./golf-clubs-digital-ordering/content.de": [
		3316,
		3316
	],
	"./golf-clubs-digital-ordering/content.de.ts": [
		3316,
		3316
	],
	"./golf-clubs-digital-ordering/content.en": [
		7174,
		6659
	],
	"./golf-clubs-digital-ordering/content.en.ts": [
		7174,
		6659
	],
	"./golf-clubs-digital-ordering/content.nl": [
		9005,
		9005
	],
	"./golf-clubs-digital-ordering/content.nl.ts": [
		9005,
		9005
	],
	"./golf-clubs-digital-ordering/metadata": [
		1332,
		1332
	],
	"./golf-clubs-digital-ordering/metadata.ts": [
		1332,
		1332
	],
	"./hotel-digital-ordering/content.de": [
		966,
		966
	],
	"./hotel-digital-ordering/content.de.ts": [
		966,
		966
	],
	"./hotel-digital-ordering/content.en": [
		7397,
		7397
	],
	"./hotel-digital-ordering/content.en.ts": [
		7397,
		7397
	],
	"./hotel-digital-ordering/content.nl": [
		9963,
		9963
	],
	"./hotel-digital-ordering/content.nl.ts": [
		9963,
		9963
	],
	"./hotel-digital-ordering/metadata": [
		8633,
		8633
	],
	"./hotel-digital-ordering/metadata.ts": [
		8633,
		8633
	],
	"./qr-ordering-restaurant-guide/content.de": [
		5766,
		5766
	],
	"./qr-ordering-restaurant-guide/content.de.ts": [
		5766,
		5766
	],
	"./qr-ordering-restaurant-guide/content.en": [
		782,
		782
	],
	"./qr-ordering-restaurant-guide/content.en.ts": [
		782,
		782
	],
	"./qr-ordering-restaurant-guide/content.nl": [
		4386,
		4386
	],
	"./qr-ordering-restaurant-guide/content.nl.ts": [
		4386,
		4386
	],
	"./qr-ordering-restaurant-guide/metadata": [
		8140,
		8140
	],
	"./qr-ordering-restaurant-guide/metadata.ts": [
		8140,
		8140
	],
	"./restaurant-kpi-guide/content.de": [
		1056,
		1056
	],
	"./restaurant-kpi-guide/content.de.ts": [
		1056,
		1056
	],
	"./restaurant-kpi-guide/content.en": [
		9791,
		9791
	],
	"./restaurant-kpi-guide/content.en.ts": [
		9791,
		9791
	],
	"./restaurant-kpi-guide/content.nl": [
		4580,
		4580
	],
	"./restaurant-kpi-guide/content.nl.ts": [
		4580,
		4580
	],
	"./restaurant-kpi-guide/metadata": [
		6619,
		6619
	],
	"./restaurant-kpi-guide/metadata.ts": [
		6619,
		6619
	],
	"./self-order-kiosks-for-hospitality/content.de": [
		6780,
		6780
	],
	"./self-order-kiosks-for-hospitality/content.de.ts": [
		6780,
		6780
	],
	"./self-order-kiosks-for-hospitality/content.en": [
		4430,
		2952
	],
	"./self-order-kiosks-for-hospitality/content.en.ts": [
		4430,
		2952
	],
	"./self-order-kiosks-for-hospitality/content.nl": [
		1695,
		1695
	],
	"./self-order-kiosks-for-hospitality/content.nl.ts": [
		1695,
		1695
	],
	"./self-order-kiosks-for-hospitality/metadata": [
		9913,
		9913
	],
	"./self-order-kiosks-for-hospitality/metadata.ts": [
		9913,
		9913
	],
	"./snackbar-digital-ordering/content.de": [
		6361,
		6361
	],
	"./snackbar-digital-ordering/content.de.ts": [
		6361,
		6361
	],
	"./snackbar-digital-ordering/content.en": [
		2451,
		2451
	],
	"./snackbar-digital-ordering/content.en.ts": [
		2451,
		2451
	],
	"./snackbar-digital-ordering/content.nl": [
		5713,
		5713
	],
	"./snackbar-digital-ordering/content.nl.ts": [
		5713,
		5713
	],
	"./snackbar-digital-ordering/metadata": [
		8466,
		8466
	],
	"./snackbar-digital-ordering/metadata.ts": [
		8466,
		8466
	],
	"./the-new-hospitality-industry/content.de": [
		4995,
		4995
	],
	"./the-new-hospitality-industry/content.de.ts": [
		4995,
		4995
	],
	"./the-new-hospitality-industry/content.en": [
		2050,
		2050
	],
	"./the-new-hospitality-industry/content.en.ts": [
		2050,
		2050
	],
	"./the-new-hospitality-industry/content.nl": [
		3930,
		3930
	],
	"./the-new-hospitality-industry/content.nl.ts": [
		3930,
		3930
	],
	"./the-new-hospitality-industry/metadata": [
		2275,
		2275
	],
	"./the-new-hospitality-industry/metadata.ts": [
		2275,
		2275
	],
	"./the-psychology-behind-upselling/content.de": [
		3298,
		3298
	],
	"./the-psychology-behind-upselling/content.de.ts": [
		3298,
		3298
	],
	"./the-psychology-behind-upselling/content.en": [
		7494,
		7494
	],
	"./the-psychology-behind-upselling/content.en.ts": [
		7494,
		7494
	],
	"./the-psychology-behind-upselling/content.nl": [
		9295,
		9295
	],
	"./the-psychology-behind-upselling/content.nl.ts": [
		9295,
		9295
	],
	"./the-psychology-behind-upselling/metadata": [
		4343,
		4343
	],
	"./the-psychology-behind-upselling/metadata.ts": [
		4343,
		4343
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 386;
module.exports = webpackAsyncContext;